import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClip, TPostClip } from '../types';

export async function postClip(body: TPostClip): Promise<TClip> {
  return mediaManagerClient.post('/api/v1/clips', emptyStringValues(body));
}

type MutationFn = typeof postClip;

type TUsePostFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostClip({ config = {} }: TUsePostFeaturedPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postClip,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el corte'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El corte se ha creado correctamente'));
      queryClient.invalidateQueries({
        queryKey: ['clips'],
        exact: false,
      });
    },
  });
}
